"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createFormatState_1 = require("./createFormatState");
var ButtonNames_1 = require("../store/schema/ButtonNames");
function createRibbonViewState() {
    return {
        visibleItemCount: ButtonNames_1.RIBBON_BUTTON_LIST.length,
        formatViewState: createFormatState_1.default(),
        cachedFormatViewState: null,
    };
}
exports.default = createRibbonViewState;
//# sourceMappingURL=createRibbonViewState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-editor-ribbonplugin/lib/utils/createRibbonViewState.js
// module id = 2229
// module chunks = 2 3 108